import React from 'react';
import { SkillsStyles } from '../styles/skills.style';

const Skills = () => {
    return (
        <SkillsStyles>
            <div className="row">
                <div className="section__title">
                    <h2 data-heading="Top">Skills</h2>
                </div>
                <div className="row full-width">
                    <div className="skill-content">
                        <div className="row">
                            <div className="skill-item">
                                <p>Html</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(90% - 1.4rem)'
                                    }}>
                                        <span>90%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>Css</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(80% - 1.4rem)'
                                    }}>
                                        <span>80%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>Javascript</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(80% - 1.4rem)'
                                    }}>
                                        <span>80%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>Typescript</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(70% - 1.4rem)'
                                    }}>
                                        <span>70%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>react</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(80% - 1.4rem)'
                                    }}>
                                        <span>80%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>Node.js</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(75% - 1.4rem)'
                                    }}>
                                        <span>75%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>Python</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(60% - 1.4rem)'
                                    }}>
                                        <span>60%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>NOSQL</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(70% - 1.4rem)'
                                    }}>
                                        <span>70%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>SQL</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(60% - 1.4rem)'
                                    }}>
                                        <span>60%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>GIT</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(70% - 1.4rem)'
                                    }}>
                                        <span>70%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>Continuous Integration</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(70% - 1.4rem)'
                                    }}>
                                        <span>70%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>UI Design</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(50% - 1.4rem)'
                                    }}>
                                        <span>50%</span>
                                    </div>
                                </div>
                            </div>
                            <div className="skill-item">
                                <p>Figma</p>
                                <div className="progress inner-shadow">
                                    <div className="progress-bar" style={{
                                        width: 'calc(50% - 1.4rem)'
                                    }}>
                                        <span>50%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SkillsStyles>
    )
}

export default Skills
